export enum ProtocolVisitRelativeTo {
    Sunrise = "Sunrise",
    Sunset = "Sunset",
    Midnight = "Midnight",
}

export type ProtocolVisitTimeslot = {
    id: string;
    startRelativeTo: ProtocolVisitRelativeTo;
    maxStartOffset: number;
    endRelativeTo: ProtocolVisitRelativeTo;
    minEndOffset: number;
    availabilityId: string;
};
